module.exports = __webpack_public_path__ + "static/img/default-avatar.69eb4a82.png";